module.exports = __webpack_public_path__ + "static/media/time.40e35d3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/time.png
// module id = 180
// module chunks = 0